/* tslint:disable:no-trailing-whitespace import-spacing no-inferrable-types typedef-whitespace component-selector */

import {
  Component,
  OnInit,
  OnDestroy
}                                from '@angular/core';

import { ActionService }         from '@/services/action.service';
import { ActionType }            from '@/models/action';
import { Logger                } from '@/util/logger';

@Component({
  selector:    '.properties-button',
  template: `
<button class="gui-button-vertical-right" (click)="execute()">
  Properties
</button>
  `})

/**
 *
 * @class PropertiesButtonComponent
 *
 * @brief vertical button for properties window
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      April 2020
 *
 */
export class PropertiesButtonComponent implements OnInit, OnDestroy {

  /** the count down to expiry */
  public expiresLabel: string = '';

  /** id for our count down timer */
  private countDownTimer: number = 0;

  constructor(
    private actions:   ActionService,
  ) {

    Logger.debug('[PropertiesButtonComponent]', 'constructing...');

  }

  /** any setup for our button */
  ngOnInit(): void {


  }

  /** clean up */
  ngOnDestroy() {


  }

  /** toggle the project window */
  execute() {

    this.actions.action(ActionType.Window_Properties).execute();

  }
}
